import { useState, useEffect } from 'react';
import { getSharedAutomations } from '../../../services/AutomationsService';
import SharedAutomationRow from './SharedAutomationRow';
import SwitchInput from '../../../components/SwitchInput';
import Pager from '../../../components/Pager';
import ViewAutomationModal from './ViewAutomationModal';

/**
 * props:
 * - onNotification
 */
function SharedAutomations(props) {
    const [automations, setAutomations] = useState([]);
    const [count, setCount] = useState(0);
    const [viewAutomation, setViewAutomation] = useState({});
    const [page, setPage] = useState(1);
    const [includePublic, setIncludePublic] = useState(true);

    useEffect(() => {
        getSharedAutomations('', includePublic, page || 1)
            .then(result => {
                setAutomations(result.rows);
                setCount(result.count);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }, [page, includePublic])

    function onViewClick(event) {
        const id = event.target.id.replace('view', '');
        setViewAutomation(automations.find(a => a.id == id));
    }

    function onPublicChange(event) {
        setIncludePublic(event.target.value);
    }

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <h2 className="h4">Automações Compartilhadas</h2>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="d-inline-flex align-items-center">
                        <SwitchInput id="includePublicAutomations" text="Incluir Públicas?" isChecked={includePublic} onChange={onPublicChange} />
                    </div>
                </div>
            </div>
            <div className="card card-body border-0 shadow table-wrapper table-responsive">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th className="border-gray-200">Símbolo</th>
                            <th className="border-gray-200">Nome</th>
                            <th className="border-gray-200">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            automations && automations.length
                                ? automations.map(automation => (<SharedAutomationRow key={automation.id} data={automation} onViewClick={onViewClick} />))
                                : <></>
                        }
                    </tbody>
                </table>
                <Pager count={count} page={page} size={10} onClick={setPage} />
            </div>
            <ViewAutomationModal data={viewAutomation} />
        </>
    )
}

export default SharedAutomations;
